<template lang="pug">
.bloco-area-plantada-produtividade-monitoramento-agricola(
    :style='divergencia ? "border: solid #f88342" : "border: none"',
    :class='desabilitar ? "is-disabled" : ""'
)
    .bloco-area-plantada__titulo
        .bloco-area-plantada__titulo-interno
            span {{ titulo }}
        .bloco-area-plantada__titulo-icone
            slot(name='icone')
                i(:class='iconeDivergencia')

    .bloco-secao
        .bloco-secao__interno-alinhamento
            span {{ subtitulo }}
        .bloco-secao__interno-dados
            .bloco-secao__interno-dados--alinhamento
                span.bloco-secao__interno--negrito {{ valorInformado }}
                span Informada
            .bloco-secao__interno--normal
                span (-)
            .bloco-secao__interno-dados--alinhamento
                span.bloco-secao__interno--negrito {{ valorMonitorado }}
                span Monitorada
            .bloco-secao__interno--normal(v-if='exibirValorDivergente')
                span (=)
            .bloco-secao__interno-dados--alinhamento(
                v-if='exibirValorDivergente'
            )
                span.bloco-secao__interno--negrito(
                    :style='valorDivergente.length > 5 ? "font-size: 18px; margin:4px 0 0 10px; padding: 0;" : ""'
                ) {{ valorDivergente }}
                span Divergência
    .bloco-secao-pag(v-if='exibirPaginacao')
        .bloco-secao__interno-dados-pag
            .bloco-secao__interno-dados--alinhamento-pag
                i.mdi.mdi-menu-left(@click='paginaAnterior')
            .bloco-secao__interno-dados--alinhamento-pag
                span {{ paginaAtual + '/' + paginaFinal }}
            .bloco-secao__interno-dados--alinhamento-pag
                i.mdi.mdi-menu-right(@click='paginaSeguinte')
</template>

<script>
export default {
    name: 'BlocoAreaPlantadaProdutividadeMonitoramentoAgricola',
    emits: ['pagina-seguinte', 'pagina-anterior'],
    props: {
        titulo: {
            type: String,
            default: () => ''
        },
        subtitulo: {
            type: String,
            default: () => ''
        },
        valorInformado: {
            type: String,
            default: () => '0'
        },
        valorMonitorado: {
            type: String,
            default: () => '0'
        },
        valorDivergente: {
            type: String,
            default: () => '0'
        },
        exibirValorDivergente: {
            type: Boolean,
            default: () => true
        },
        divergencia: {
            type: Boolean,
            default: () => false
        },
        iconeDivergencia: {
            type: String,
            default: () => 'mdi mdi-check-circle-outline'
        },
        exibirPaginacao: {
            type: Boolean,
            default: () => false
        },
        paginaAtual: {
            type: Number,
            default: () => 1
        },
        paginaFinal: {
            type: Number,
            default: () => 1
        },
        desabilitar: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {};
    },
    methods: {
        paginaSeguinte() {
            this.$emit('pagina-seguinte');
        },
        paginaAnterior() {
            this.$emit('pagina-anterior');
        }
    }
};
</script>

<style lang="scss" scoped>
.bloco-area-plantada-produtividade-monitoramento-agricola {
    min-width: 24%;
    background: var(--white);
    border-radius: 5px;
    display: flex;
    min-height: 89px;
    align-items: center;
    color: var(--primary);
    flex-wrap: wrap;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    padding: 12px 10px 0px;
    flex-direction: column;
    .bloco-area-plantada__titulo {
        display: flex;
        justify-content: space-between;
        align-self: normal;
    }
    .bloco-area-plantada__titulo-interno {
        width: 90%;
        font-size: 16px;
        font-weight: 600;
        display: flex;
        justify-content: center;
        margin-left: 31px;
        a.el-link {
            font-size: 20px;
            margin: -2px 0 0 5px;
        }
        a.el-link:not(.is-disabled):hover {
            color: var(--secondary-two);
        }
        a.el-link.is-disabled:hover {
            color: #c0c4cc;
        }
    }
    .bloco-area-plantada__titulo-icone {
        width: 10%;
        font-size: 22px;
        display: flex;
        justify-content: flex-end;
        .mdi-alert-outline {
            color: #f88342;
        }
        .mdi-check-circle-outline {
            color: var(--secondary-two);
        }
    }
    .bloco-secao-pag {
        margin-right: 3px;
        display: flex;
        text-align: center;
        justify-content: space-between;
        width: 100%;
        flex-direction: column;
        margin-top: 10px;
        .bloco-secao__interno-dados-pag {
            display: flex;
            justify-content: space-evenly;
            border-top: solid 1px;
            height: 35px;
            .bloco-secao__interno-dados--alinhamento-pag {
                display: flex;
                align-items: center;
                .mdi::before {
                    font-size: 40px !important;
                    color: var(--primary) !important;
                    height: 35px;
                    align-items: center;
                    display: flex;
                }
            }
        }
    }
    .bloco-secao {
        margin-right: 3px;
        display: flex;
        text-align: center;
        justify-content: space-between;
        width: 100%;
        flex-direction: column;
        margin-top: 16px;
        .bloco-secao__interno-alinhamento {
            font-weight: 600;
            display: flex;
            justify-content: center;
        }
        .bloco-secao__interno-dados {
            display: flex;
            justify-content: center;
            .bloco-secao__interno--normal {
                display: flex;
                justify-content: center;
                align-items: flex-start;
                padding-top: 0.2rem;
            }
        }
        .bloco-secao__interno--negrito {
            font-size: 22px;
            font-weight: 600;
            display: flex;
            justify-content: center;
            padding: 0 1rem;
        }
        .lyra-icon::before {
            content: '';
            width: 54px !important;
            height: 54px !important;
            background-color: var(--primary) !important;
        }
        .mdi::before {
            font-size: 50px !important;
            color: var(--primary) !important;
        }
    }

    span {
        padding: 3px;
        &.bloco-area-plantada__interno-subtitulo {
            max-width: 184px;
            font-weight: 600;
        }
    }

    &:first-child {
        margin: 2px 3px 2px 0px;
    }

    &:not(:first-child) {
        margin: 2px 3px 2px 2px;
    }
    &.is-disabled {
        color: #c0c4cc;
        cursor: default;
    }
}
</style>
